export default "__VITE_PUBLIC_ASSET__68784231__"